'use strict';

/**
 * Global integration of JavaScript files by integrating account.js into main.js.
 */

var processInclude = require('base/util');

$(() => {
    processInclude(require('./account/account'));
    //PWC include new affiliateAccount client js file
    processInclude(require('./account/affiliateAccount'));
    //PWC-NOA-1260 include deactivate account client js file
    processInclude(require('./account/deactivateAccount'));
});
